import React from 'react'
import RiskHorizontalDisplay from './RiskHorizontalDisplay'

const ExportPdf = ({ feedbackDetailData, selectedIndex }) => {
  const {
    id,
    title,
    content,
    endDate,
    legalBasis,
    feedbackComments,
    agreeRate,
  } = feedbackDetailData
  const contentData = feedbackComments?.find(
    item => item.id === Number(selectedIndex)
  )
  const eday = endDate && endDate?.split('-')[0]
  const emonth = endDate && endDate?.split('-')[1]
  const eyear = endDate && endDate?.split('-')[2]

  return (
    <div
      id="divToPrintPart1"
      style={{ margin: '20mm', pageBreakInside: 'avoid' }}>
      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold' }}>CÔNG TY CỔ PHẦN</div>
                <div style={{ fontWeight: 'bold' }}>
                  ĐẠI LÝ HÀNG HẢI VIỆT NAM
                </div>
                <div>---------------------</div>
                <div>
                  Số: {String(agreeRate).padStart(2, '0')}/
                  {new Date().getFullYear()}
                </div>
              </div>
            ),
            style: { margin: '10px', border: '1px solid white' },
          },
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold' }}>
                  CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                </div>
                <div style={{ fontWeight: 'bold' }}>
                  Độc lập - tự do - hạnh phúc{' '}
                </div>
                <div>---------------------</div>
                <div style={{ fontStyle: 'italic', fontWeight: 'semibold' }}>
                  TP. Hồ Chí Minh, ngày {new Date().getDate()} tháng{' '}
                  {new Date().getMonth() + 1} năm {new Date().getFullYear()}
                </div>
              </div>
            ),
            style: {
              margin: '10px 0 10px 10px',
              border: '1px solid white',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        labels={[
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <h5>PHIẾU XIN Ý KIẾN</h5>
                <div>
                  Kính gửi: Thành viên Hội đồng quản trị CTCP Đại lý Hàng hải
                  Việt Nam
                </div>
              </div>
            ),
            style: { margin: '10px 0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 100px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div>
                <div
                  style={{
                    margin: '0 0 8px 0',
                    textAlign: 'justify',
                    lineHeight: '1.2',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: contentData && contentData?.content,
                  }}></div>
                <div
                  style={{
                    margin: '0 0 8px 0',
                    textAlign: 'justify',
                    lineHeight: '1.2',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: legalBasis && legalBasis,
                  }}></div>
              </div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '10px 0 0 40px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{}}>
                <span
                  style={{
                    fontWeight: 'bold',
                    display: 'inline',
                  }}>
                  *
                </span>
                <span
                  style={{
                    margin: '0 0 8px 0',
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                  }}>
                  Vấn đề xin ý kiến:
                </span>
                <span
                  style={{
                    margin: '0 0 8px 0',
                    textAlign: 'justify',
                    lineHeight: '1.2',
                  }}>
                  {title && title}
                </span>
              </div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '100%' }}
      />

      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{}}>
                <div
                  style={{
                    margin: '0 0 8px 0',
                  }}>
                  <span
                    style={{
                      fontWeight: 'bold',
                      display: 'inline',
                    }}>
                    *
                  </span>
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                    Tài liệu kèm theo:
                  </span>
                  <span
                    style={{
                      margin: '0 0 8px 0',
                      textAlign: 'justify',
                      lineHeight: '1.2',
                    }}>
                    {' '}
                    được gửi đến các thành viên HĐQT qua email;
                  </span>
                </div>
                <div
                  dangerouslySetInnerHTML={{ __html: content && content }}
                  style={{
                    margin: '0 0 8px 0',
                    textAlign: 'justify',
                    lineHeight: '1.2',
                  }}></div>
              </div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{}}>
                <div
                  style={{
                    margin: '0 0 8px 0',
                  }}>
                  <span
                    style={{
                      fontWeight: 'bold',
                      display: 'inline',
                    }}>
                    *
                  </span>
                  <span
                    style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                    Thời hạn trả lời:
                  </span>
                  <span
                    style={{
                      margin: '0 0 8px 0',
                      textAlign: 'justify',
                      lineHeight: '1.2',
                    }}>
                    {' '}
                    Bình thường
                  </span>
                </div>
              </div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '100%' }}
      />
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div>
                <div
                  style={{
                    margin: '0 0 8px 0',
                  }}>
                  <span>- Đề nghị trả lời </span>
                  <span
                    style={{
                      margin: '0 0 8px 0',
                      fontWeight: 'bold',
                    }}>
                    Trước ngày {eday}/{emonth}/{eyear}.
                  </span>
                </div>
              </div>
            ),
            style: {
              textAlign: 'flex',
              border: '1px solid white',
              margin: '0 10px',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: '100%' }}
      />

      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div
                style={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  display: 'none',
                }}>
                <div></div>
              </div>
            ),
            style: { margin: '10px', border: '1px solid white' },
          },
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <div>T/L. CHỦ TỊCH HĐQT</div>
                <div>NGƯỜI PHỤ TRÁCH QUẢN TRỊ</div>
              </div>
            ),
            style: {
              margin: '10px 0 10px 10px',
              border: '1px solid white',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 200px 350px', width: '100%' }}
      />
    </div>
  )
}

export default ExportPdf
